

function HeaderStep({ step, title, custom }) { // component to manage the first step of shopping : choosing place and time


    return (
        <div className="header-step">

            <div className="header-step-left">
                <div className="header-step-number">
                    <h2>{step}</h2>
                </div>
                <h2 className="header-step-title">{title}</h2>
            </div>

            <div className="header-step-right">
                {custom /* component sent as prop */}
            </div>
        </div>

    )
}




export default HeaderStep